import { ParsedUrlQuery } from 'querystring';

// Valid PDP URL's look like https://www.zoopla.co.uk/property/uprn/100021550049
export const getUPRNfromQuery = (query?: ParsedUrlQuery) => {
    if (
        query?.['property-with-address']?.length !== 2 ||
        query?.['property-with-address'][0] !== 'uprn' ||
        !Number(query['property-with-address'][1])
    ) {
        return null;
    }

    return query['property-with-address'][1];
};
